import { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useCadaverService } from 'hooks/useCadaverService'

export const useFormFenomenosCadavericos = ({ idExameRealizado, idCadaver }) => {
  const cadaverService = useCadaverService()
  const dispatch = useDispatch()
  const [processandoFenomenos, setProcessandoFenomenos] = useState(false)
  const [idFenomenoSelecionado, setIdFenomenoSelecionado] = useState(-1)
  const [openFichaDeletarFenomenoCadaverico, setOpenFichaDeletarFenomenoCadaverico] = useState(false)
  const [openAddFenomeno, setOpenAddFenomeno] = useState(false)
  const [fenomenosCadavericos, setFenomenosCadavericos] = useState([])

  const fetchFenomenos = useCallback(() => {
    if (idCadaver) {
      cadaverService.getFenomenosCadavericosCadaver(
        idExameRealizado,
        idCadaver,
        setFenomenosCadavericos,
        setProcessandoFenomenos
      )
    }
  }, [idCadaver, idExameRealizado])

  useEffect(() => {
    fetchFenomenos()
  }, [fetchFenomenos])

  const handleBotaoAdicionarFenomenoCadaverico = () => {
    setOpenAddFenomeno(true)
  }

  const clickOpenModalDeletarFenomenoCadaverico = (rowData) => {
    setIdFenomenoSelecionado(rowData.id)
    setOpenFichaDeletarFenomenoCadaverico(true)
  }

  const handleCloseModalDeletarFenomenoCadaverico = () => {
    setIdFenomenoSelecionado(-1)
    setOpenFichaDeletarFenomenoCadaverico(false)
  }

  const handleDeletarFenomenoCadaverico = async () => {
    setOpenFichaDeletarFenomenoCadaverico(false)
    await cadaverService.excluirFenomenoCadaverico(idFenomenoSelecionado, setProcessandoFenomenos)
    fetchFenomenos()
  }

  return {
    processandoFenomenos,
    fenomenosCadavericos,
    setFenomenosCadavericos,
    openAddFenomeno,
    setOpenAddFenomeno,
    openFichaDeletarFenomenoCadaverico,
    handleBotaoAdicionarFenomenoCadaverico,
    clickOpenModalDeletarFenomenoCadaverico,
    handleCloseModalDeletarFenomenoCadaverico,
    handleDeletarFenomenoCadaverico,
    setProcessandoFenomenos,
    dispatch,
    fetchFenomenos,
  }
}
